import { render, staticRenderFns } from "./TaskTypeCheckingAct.vue?vue&type=template&id=263fa506&scoped=true"
import script from "./TaskTypeCheckingAct.vue?vue&type=script&lang=js"
export * from "./TaskTypeCheckingAct.vue?vue&type=script&lang=js"
import style0 from "./TaskTypeCheckingAct.vue?vue&type=style&index=0&id=263fa506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263fa506",
  null
  
)

export default component.exports